export function countDown(min: number, sec: number, cb: Function) {
  if (sec === 0 && min !== 0) {
    return cb({ min: min - 1, sec: 59 });
  } else if (sec > 0) {
    if (sec > 10) {
      return cb({ min: min, sec: sec - 1 });
    } else {
      return cb({ min: min, sec: sec - 1 });
    }
  }
}
